exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0d09056c] .el-date-editor{width:100%}[data-v-0d09056c] .el-textarea__inner{resize:none}[data-v-0d09056c] .el-input-number{width:100%}[data-v-0d09056c] .el-select{width:100%}[data-v-0d09056c] .el-form-item:last-of-type{margin-bottom:0}[data-v-0d09056c] .el-dialog__footer{padding:20px 0}.dialog-footer[data-v-0d09056c]{padding-top:20px;padding-right:20px;border-top:1px solid #e6ebf5}\n", ""]);

// exports
